import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenNikeDFShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[1].productName}
				color={product.allGear[1].color}
				size={product.allGear[1].sizes}
				price={product.allGear[1].price}
				img={product.allGear[1].img}
				miniImg1={product.allGear[1].miniImg1}
				miniImg2={product.allGear[1].miniImg2}
				miniImg3={product.allGear[1].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenNikeDFShirt;
